import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../components/Header";
import ProfileTabs from "../components/profileComponents/ProfileTabs";
import { getUserDetails } from "../Redux/Actions/userActions";
import Orders from "./../components/profileComponents/Orders";
import moment from "moment";
import { listMyOrders } from "../Redux/Actions/OrderActions";
import MobileNav from "../components/MobileNav";
// import ShareButton from "../components/ShareButton";
import MemberCard from "../components/profileComponents/MemberCard";

const ProfileScreen = () => {
  window.scrollTo(0, 0);
  const [activeTab, setActiveTab] = useState("orders");
  const [url, setUrl] = useState("https://aarohfood.uk/register/");

  const brandName = "Aarohfood";
  const whatsappMessage =
    `
🌾 *${brandName}: Your Trusted Online Grocery Store!* 🛒

      Order fresh groceries delivered right to your doorstep with just a few clicks. 🍎🥦🥖

      ✨ *Why ${brandName}?* ✨
      ✅ Convenient Online Ordering
      ✅ Fresh and Quality Products
      ✅ Fast and Reliable Delivery

      📢 *Special Offer: Become a Member!* 📢
      Register now and become a member of ${brandName} to enjoy exclusive benefits:
      🎉 Win a fantastic trip every year!
      💵 Earn extra income through our referral program!

      *Don't miss out! Register today and experience the convenience of ${brandName}.* 🌟

      Click the link to get started: ` +
    url +
    ` 🛒
`.trim();

  const dispatch = useDispatch();

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const orderListMy = useSelector((state) => state.orderListMy);
  const { orders } = orderListMy;

  // const totalOrders = orders?.result?.length || 0;

  useEffect(() => {
    dispatch(listMyOrders());
    dispatch(getUserDetails("profile"));
    if (userInfo) setUrl("https://aarohfood.uk/register/" + userInfo._id);
  }, [dispatch, userInfo]);

  return (
    <>
      <Header />
      <MobileNav />

      <div className="profile-page-wrapper">
        <div className="container">
          <div className="row g-4 align-items-start">

            {/* ── LEFT SIDEBAR ── */}
            <div className="col-lg-3 col-md-4">
              <div className="profile-sidebar">

                {/* Banner header */}
                <div 
                  className="profile-sidebar-header"
                  style={{ backgroundImage: "url('./images/profilebanner.png')" }}
                >
                  <div className="profile-avatar-wrapper">
                    <img
                      src="./images/user.png"
                      alt="profile"
                      className="profile-avatar"
                    />
                    <span className="profile-avatar-badge"></span>
                  </div>
                </div>

                {/* Name + joined */}
                <div className="profile-sidebar-body">
                  <div className="profile-user-name">{userInfo?.name}</div>
                  <div className="profile-user-meta">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                      <line x1="16" y1="2" x2="16" y2="6"/>
                      <line x1="8" y1="2" x2="8" y2="6"/>
                      <line x1="3" y1="10" x2="21" y2="10"/>
                    </svg>
                    Joined {moment(userInfo?.createdAt).format("DD MMM YYYY")}
                  </div>

                  {/* Quick stats */}
                  <div className="profile-stats-row">
                    <div className="profile-stat-item">
                      <div className="stat-icon-wrapper blue-icon">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
                          <line x1="3" y1="6" x2="21" y2="6"></line>
                          <path d="M16 10a4 4 0 0 1-8 0"></path>
                        </svg>
                      </div>
                      <div className="profile-stat-value">{orders?.total || 0}</div>
                      <div className="profile-stat-label">Orders</div>
                    </div>
                    
                    <div className="profile-stat-item">
                      <div className="stat-icon-wrapper green-icon">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <rect x="1" y="3" width="15" height="13"></rect>
                          <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon>
                          <circle cx="5.5" cy="18.5" r="2.5"></circle>
                          <circle cx="18.5" cy="18.5" r="2.5"></circle>
                        </svg>
                      </div>
                      <div className="profile-stat-value">
                        {orders?.result?.filter(o => o.isDelivered).length || 0}
                      </div>
                      <div className="profile-stat-label">Delivered</div>
                    </div>
                    
                    <div className="profile-stat-item">
                      <div className="stat-icon-wrapper red-icon">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <circle cx="12" cy="12" r="10"></circle>
                          <line x1="12" y1="8" x2="12" y2="12"></line>
                          <line x1="12" y1="16" x2="12.01" y2="16"></line>
                        </svg>
                      </div>
                      <div className="profile-stat-value">
                        {orders?.result?.filter(o => !o.isPaid && !o.isCOD).length || 0}
                      </div>
                      <div className="profile-stat-label">Unpaid</div>
                    </div>
                  </div>

                  {/* Navigation */}
                  <nav className="profile-nav">
                    <button
                      className={`profile-nav-btn ${activeTab === "settings" ? "active" : ""}`}
                      onClick={() => setActiveTab("settings")}
                    >
                      <span className="pnav-icon">⚙️</span>
                      <span className="pnav-label">Profile Settings</span>
                      <span className="pnav-arrow">›</span>
                    </button>

                    <button
                      className={`profile-nav-btn ${activeTab === "orders" ? "active" : ""}`}
                      onClick={() => setActiveTab("orders")}
                    >
                      <span className="pnav-icon">🛍️</span>
                      <span className="pnav-label">Order List</span>
                      <span className="pnav-arrow">›</span>
                    </button>

                    <div className="profile-nav-divider" />

                    <button
                      className="profile-nav-btn whatsapp-nav-btn"
                      onClick={() => {
                        const waUrl = `https://wa.me/?text=${encodeURIComponent(whatsappMessage)}%20${encodeURIComponent("https://aarohfood.uk/register/" + userInfo?._id)}`;
                        window.open(waUrl, "_blank");
                      }}
                    >
                      <span className="pnav-icon" style={{ background: "#dcfce7" }}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="20" height="20">
                          <circle cx="24" cy="24" r="24" fill="#25D366"/>
                          <path fill="#fff" d="M34.5 13.5A14.4 14.4 0 0 0 24 9C16.27 9 10 15.27 10 23a13.9 13.9 0 0 0 1.87 7L9 39l9.23-2.42A14 14 0 0 0 24 38c7.73 0 14-6.27 14-14a13.9 13.9 0 0 0-3.5-10.5ZM24 35.5a11.5 11.5 0 0 1-5.87-1.6l-.42-.25-4.35 1.14 1.16-4.24-.27-.44A11.44 11.44 0 0 1 12.5 23C12.5 16.6 17.6 11.5 24 11.5c3.07 0 5.96 1.2 8.13 3.37A11.44 11.44 0 0 1 35.5 23c0 6.4-5.1 11.5-11.5 11.5Zm6.3-8.6c-.35-.17-2.05-1.01-2.37-1.13-.32-.11-.55-.17-.78.18s-.9 1.13-1.1 1.36-.4.26-.75.09a9.4 9.4 0 0 1-2.77-1.71 10.4 10.4 0 0 1-1.92-2.38c-.2-.35 0-.53.15-.7l.5-.58c.16-.19.2-.35.3-.58.1-.23.05-.43-.03-.6s-.78-1.88-1.07-2.57c-.28-.68-.57-.58-.78-.59h-.66c-.23 0-.6.09-.91.43-.32.35-1.2 1.17-1.2 2.85s1.23 3.3 1.4 3.53c.17.23 2.42 3.7 5.87 5.18.82.35 1.46.56 1.96.72.82.26 1.57.22 2.16.13.66-.1 2.05-.84 2.34-1.65.29-.8.29-1.5.2-1.64-.08-.15-.3-.23-.65-.4Z"/>
                        </svg>
                      </span>
                      <span className="pnav-label">Share on WhatsApp</span>
                      <span className="pnav-arrow">›</span>
                    </button>
                  </nav>
                </div>

                {/* Member Card */}
                <MemberCard cardData={userInfo} />
              </div>
            </div>

            {/* ── RIGHT CONTENT ── */}
            <div className="col-lg-9 col-md-8">
              
              {/* Top Stats Row */}
              <div className="profile-top-stats-row">
                {/* 1. Total Orders */}
                <div className="top-stat-card green-card">
                  <div className="top-stat-icon-box">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
                      <line x1="3" y1="6" x2="21" y2="6"></line>
                      <path d="M16 10a4 4 0 0 1-8 0"></path>
                    </svg>
                  </div>
                  <div className="top-stat-info">
                    <div className="top-stat-title">Total Orders</div>
                    <div className="top-stat-number">{orders?.total || 0}</div>
                    <div className="top-stat-subtitle">All time orders</div>
                  </div>
                  <i className="fas fa-shopping-bag top-stat-bg-icon"></i>
                </div>

                {/* 2. Order List */}
                <div className="top-stat-card blue-card">
                  <div className="top-stat-icon-box">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                      <polyline points="14 2 14 8 20 8"></polyline>
                      <line x1="16" y1="13" x2="8" y2="13"></line>
                      <line x1="16" y1="17" x2="8" y2="17"></line>
                      <polyline points="10 9 9 9 8 9"></polyline>
                    </svg>
                  </div>
                  <div className="top-stat-info">
                    <div className="top-stat-title">Order List</div>
                    <div className="top-stat-number">{orders?.result?.length || 0}</div>
                    <div className="top-stat-subtitle">View your orders</div>
                  </div>
                  <i className="fas fa-clipboard-list top-stat-bg-icon"></i>
                </div>

                {/* 3. Reward Points */}
                <div className="top-stat-card yellow-card">
                  <div className="top-stat-icon-box">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                    </svg>
                  </div>
                  <div className="top-stat-info">
                    <div className="top-stat-title">Reward Points</div>
                    <div className="top-stat-number">450</div>
                    <div className="top-stat-subtitle">Available points</div>
                  </div>
                  <i className="fas fa-gift top-stat-bg-icon"></i>
                </div>
              </div>

              <div className="profile-content-panel">

                {/* Panel Header */}
                <div className="profile-panel-header">
                  <div className="profile-panel-icon">
                    {activeTab === "orders" ? "🛍️" : "⚙️"}
                  </div>
                  <div>
                    <div className="profile-panel-title">
                      {activeTab === "orders" ? "Order List" : "Profile Settings"}
                    </div>
                    <div className="profile-panel-subtitle">
                      {activeTab === "orders"
                        ? "Track and manage all your orders"
                        : "Update your account details"}
                    </div>
                  </div>
                </div>

                {/* Panel Body */}
                <div className="profile-panel-body">
                  {activeTab === "orders" ? <Orders /> : <ProfileTabs />}
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default ProfileScreen;
